import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import BreadcrumbSection from "../../components/Breadcrumb/BreadcrumbSection";
import { blackColor } from "../../configs/styles/muiThemes";
import OndcCategoryPreview from "./Preview/OndcCategoryPreview";
import ProductDetailPreview from "./Preview/ProductDetailPreview";
import SelectVariancePreview from "./Preview/SelectVariancePreview";
import OndcDataPreview from "./Preview/OndcDataPreview";
import VaraintProductPreview from "./Preview/VaraintProductPreview";
import VariantOndcPreview from "./Preview/VariantOndcPreview";
import { stickyHeader } from "../../utils/styles";
import {
  getDefaultProductDetailsTable,
  getOndcDetailsVariantTableHeader,
  getProductDetailsTableHeader,
} from "../../utils/helper";
import MobileVariantDetails from "./Preview/MobileVariantDetails";

function ViewProductVariantContent({
  categoryData,
  productInfo,
  ondcDetails,
  selectedVariant,
  variantData,
  tableHeader1,
  tableHeader2,
  mobileTableHeader,
  view,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const businessName = sessionStorage.getItem("costboWEBURL");

  return (
    <Box mt={{ md: 0, xs: 1 }} pb={2}>
      <Box
        sx={{
          ...stickyHeader,
          display: { md: "block", xs: "none" },
          pb: 1,
        }}
      >
        <BreadcrumbSection
          links={[
            { label: "Product Catalog", to: `/${businessName}/catalog` },
            { label: "Product Details", to: `#` },
            { label: productInfo?.productName, to: `#` },
          ]}
        />
        <Typography
          component="h6"
          fontSize={{ xs: 15, md: 17 }}
          color={blackColor}
          fontWeight={{ xs: 600, md: 600 }}
          lineHeight="20px"
          display="inline"
        >
          Product Detail
        </Typography>
      </Box>
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          pb: 1,
          pt: 2,
        }}
      >
        {/* <BreadcrumbSection links={links} /> */}
        <Typography
          component="h6"
          fontSize={{ xs: 15, md: 17 }}
          color={blackColor}
          fontWeight={{ xs: 600, md: 600 }}
          lineHeight="20px"
          display="inline"
        >
          Product Detail
        </Typography>
      </Box>

      <OndcCategoryPreview
        categoryData={categoryData}
        productInfo={productInfo}
      />
      <ProductDetailPreview productInfo={productInfo} />
      <SelectVariancePreview
        variant1={selectedVariant?.variant1}
        variant2={selectedVariant?.variant2}
        view={view}
      />
      <OndcDataPreview
        ondcEnabled={ondcDetails?.ondcEnabled?.toLowerCase() == "yes"}
        timeToShip={ondcDetails?.timeToShip}
        timeUnit={ondcDetails?.timeUnit}
        cod={ondcDetails?.cod}
        fragile={ondcDetails?.fragile}
        returnable={ondcDetails?.returnable}
        returnPeriod={ondcDetails?.returnPeriod}
        sellerPickup={ondcDetails?.sellerPickup}
        cancellable={ondcDetails?.cancellable}
        refundEligible={ondcDetails?.refundEligible}
        cancellationFee={ondcDetails?.cancellationFee}
        dynamicSpecs={ondcDetails?.dynamicSpecs}
        productCode={ondcDetails?.productCode}
        productCodeValue={ondcDetails?.productCodeValue}
        unitOfMeasure={ondcDetails?.unitOfMeasure}
        unitOfMeasureValue={ondcDetails?.unitOfMeasureValue}
      />
      {matches ? (
        <>
          <VaraintProductPreview
            variantData={variantData}
            header={[...tableHeader1, { title: "Main", id: "100" }]}
          />
          <VariantOndcPreview variantData={variantData} header={tableHeader2} />
        </>
      ) : (
        <MobileVariantDetails
          variantData={variantData}
          header={mobileTableHeader}
        />
      )}
    </Box>
  );
}

export default ViewProductVariantContent;
